import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

interface UpdateProductTypeModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (productType: string) => void;
  currentProductType: string | null;
  saving: boolean;
}

export default function UpdateProductTypeModal({
  open,
  onClose,
  onSave,
  currentProductType,
  saving,
}: UpdateProductTypeModalProps) {
  const [selectedProductType, setSelectedProductType] = useState<string | null>(
    currentProductType,
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: adding currentProductType would change when this runs
  useEffect(() => {
    if (open) {
      setSelectedProductType(currentProductType);
    }
  }, [open]);

  const handleSave = () => {
    if (selectedProductType) {
      onSave(selectedProductType);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Product Type</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            mb: 2.5,
            py: 1.5,
            px: 2,
            backgroundColor: "grey.50",
            borderRadius: 1,
          }}
        >
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Current Product Type
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {currentProductType || "N/A"}
          </Typography>
        </Box>
        <FormControl fullWidth>
          <InputLabel disableAnimation shrink>
            New Product Type
          </InputLabel>
          <Select
            label="New Product Type"
            value={selectedProductType}
            onChange={(e) => setSelectedProductType(e.target.value)}
            fullWidth
          >
            <MenuItem value="PPO">PPO</MenuItem>
            <MenuItem value="DHMO">DHMO</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
